import { SearchComponent } from './search';

export * from './search';

export const SearchAtoms = [
    SearchComponent
]
